import React from 'react'
import '../styles/contactme.css'
import { useTranslation } from 'react-i18next';

const ContactMe = () => {

    const { t } = useTranslation('contactme');
    
    return (
        <div className='bl-contact'>
            <div className='bl-contact-container'>
                <div className='gr-contact-content'>
                    <div className='el-contact-title'>
                        {t('contactme-title')}
                    </div>
                    <div className='gr-contact-email'>
                        <img className='el-contact-arrow' alt='arrow' src='/icons/icon-long-arrow.svg'/>
                        <div className='el-contact-email'>
                            <a href='mailto:hi@pltnf.com'>
                                hi@pltnf.com
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactMe